module.exports = __webpack_public_path__ + "static/media/logo.431bde4b.svg";